/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { Theme as MaterialUITheme } from '@rjsf/material-ui';
import { Typography } from '@material-ui/core';
import { templates, widgets, fields } from '../submission/templates';
import withTheme from '../submission/rjsf/withTheme';

const MuiForm = withTheme(MaterialUITheme);

const useStyles = makeStyles(theme => ({
  heading: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'space-between',
  },
  description: {
    maxWidth: 600,
  },
  buttons: {
    display: 'flex',
    flex: '1',
    flexFlow: 'row wrap',
    justifyContent: 'flex-end',
    margin: theme.spacing(4),
  },
  editButton: {
    margin: theme.spacing(2),
    padding: theme.spacing(4),
  },
  deleteButton: {
    margin: theme.spacing(2),
    padding: theme.spacing(4),
  },
  buttonIcon: {
    marginRight: theme.spacing(2),
  },
}));

export default function OrganizationForm({
  uiSchema,
  jsonSchema,
  organization,
  updateOrganization,
  checkIfFormIsValid,
  editMode,
}) {
  const idPrefix = 'organizationForm';
  const { t } = useTranslation();

  const classes = useStyles();

  const onFormChange = (form) => {
    checkIfFormIsValid(form);
    updateOrganization(form.formData);
  };

  const transformErrors = errors => errors;
  const onError = () => {
    // not implemented yet
  };

  return (
    <>
      <div className={classes.heading}>
        <div>
          <Typography data-testid={`${idPrefix}.title`} variant="h1" className={classes.title}>
            {!editMode ? t('user.management-organisationForm.title') : t('user.management-organisationForm.edit.title')}
          </Typography>
          <Typography data-testid={`${idPrefix}.description`} variant="body1" className={classes.description}>
            {!editMode
              ? t('user.management-organisationForm.description')
              : t('user.management-organisationForm.edit.description')}
          </Typography>
        </div>
      </div>
      <MuiForm
        translation={t}
        className={classes.form}
        idPrefix={idPrefix}
        id={idPrefix}
        schema={jsonSchema}
        uiSchema={uiSchema}
        fields={fields}
        widgets={widgets}
        templates={templates}
        formData={organization}
        onChange={onFormChange}
        onError={onError}
        showErrorList={false}
        transformErrors={transformErrors}
        disabled={false}
      >
        <></>
      </MuiForm>
    </>
  );
}
